import feathersClient from "../../feathers-client";

const defaultTierMappingPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultTierMappingPaginationFilter = {
	$skip:defaultTierMappingPagination.$skip,
	$limit: defaultTierMappingPagination.$limit
};

export default {
	state:{
		tierMapping:[],
		tierMappingPagination:defaultTierMappingPagination,
		tierMappingPaginationFilter:defaultTierMappingPaginationFilter
	},
	getters:{
		setTierMappingPage:(state) => {
			const {$limit, $skip} = state.tierMappingPagination;
			return $skip / $limit + 1;
		},
	},
	mutations:{
		SET_TIER_MAPPING:(state,data) => {state.tierMapping = data;},
		SET_TIER_MAPPING_PAGINATION:(state, data) => {state.tierMappingPagination = {...state.tierMappingPagination, ...data};},
		SET_TIER_MAPPING_PAGINATION_FILTER:(state,data) => {state.tierMappingPaginationFilter  = {...state.tierMappingPaginationFilter, ...data};}
	},
	actions:{
		settierMappingListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.tierMappingPagination.$limit;
			commit('SET_TIER_MAPPING_PAGINATION', { $skip });
			commit('SET_TIER_MAPPING_PAGINATION_FILTER', { $skip });
		},

		getTierMapping: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').find({
				query:{
					$role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_TIER_MAPPING',results.data);
			commit('SET_TIER_MAPPING_PAGINATION', {total :results.total})
			return results.data;
		},
		createTierMapping: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateTierMapping: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').patch(data.id, data,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteTierMapping: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').remove(id,{
				query:{
					// $role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getTierMappingById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').get(id,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllTierMappingForTrust: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').find({
				query:{
					// $role:rootGetters.currentUserRole,
					...filter,

				}
			});
			commit('SET_TIER_MAPPING',results.data);
			commit('SET_TIER_MAPPING_PAGINATION', {total :results.total})
			return results.data;
		},
		getAllTierMapping: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/rate-escalation-tier-configurations').find({
				query:{
					// $role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		},

	}
}
